import { render, staticRenderFns } from "./agency.vue?vue&type=template&id=ff8c95ca&scoped=true"
import script from "./agency.vue?vue&type=script&lang=js"
export * from "./agency.vue?vue&type=script&lang=js"
import style0 from "./agency.vue?vue&type=style&index=0&id=ff8c95ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8c95ca",
  null
  
)

export default component.exports